
jQuery(document).ready(function($){

    setInterval(function(){

        var BOX_TOP_MARGIN      = 30;
        var BOX_MIN_HEIGHT      = 30;
        var ADJUST_OFFSET       = 44.8333;

        $.each($(".parallax-box"), function(index, el){

            var scroll_top              = $(window).scrollTop();

            var text_el                 = $(el).find(".effect-name");
            var box_el                  = $(el).find(".blue-box");

            var top_distance            = $(text_el).offset().top;

            var bottom_distance         = $(window).height() - top_distance - $(text_el).width(); //Poichè applicata transazione, l'height diventa width

            var box_height              = ADJUST_OFFSET + bottom_distance + (scroll_top);
            var box_top                 = ADJUST_OFFSET - bottom_distance - (scroll_top);

            var box_top_limit           = (ADJUST_OFFSET - $(text_el).width()) - BOX_TOP_MARGIN;
            
            //console.log(scroll_top + "|" + $(text_el).offset().top + "|" + ($(text_el).offset().top+$(text_el).width()));

            //console.log(box_top_limit);

            if(box_top >= box_top_limit){
                $(text_el).css('visibility', 'hidden');

            }else{

                box_top                     = box_top_limit;

                $(text_el).css('visibility', 'visible');

                var max                     = ($(text_el).offset().top+$(text_el).width());
                var min                     = $(text_el).offset().top;

                var mapped_min              = BOX_MIN_HEIGHT;
                var mapped_max              = $(text_el).width() + ADJUST_OFFSET;

                var x                       = scroll_top + 600;

                box_height                  = mapped_max + ((mapped_min-mapped_max)/(max-min))*(x-min);

                if(box_height > mapped_max){
                    box_height    = mapped_max;
                }

                if(box_height < mapped_min){
                    box_height    = mapped_min;
                }

                //console.log("MAX: " + max + ", MIN:" + min + ", M_MIN:" + mapped_min + ", M_MAX:" + mapped_max + ", LI: " + box_height + ", X:" + $(window).scrollTop());
            }
            
            $(box_el).css({'top'       : box_top + 'px'});
            $(box_el).css({'height'    : box_height + 'px'});
            
        });

    }, 50);


});